import { TaskType } from '@shared/enums/task-type.enum';

export const TaskTypeList: Array<TaskTypeItem> = [
  {
    name: 'Tasks.TaskType.task',
    type: TaskType.TYPE_TASK
  },
  {
    name: 'Tasks.TaskType.change',
    type: TaskType.TYPE_CHANGE
  },
  {
    name: 'Tasks.TaskType.order',
    type: TaskType.TYPE_ORDER
  },
  {
    name: 'Tasks.TaskType.correction',
    type: TaskType.TYPE_CORRECTION
  }
];

export interface TaskTypeItem {
  name: string;
  type: TaskType;
}
